import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Layout from '../Layout';
import Back from '../../../components/common/Back';
import { fetchUserProfile, updateUserProfile, clearMessage } from '../../../redux/slices/customer/configurationSlice';
import '../../../global.css';

const Profile = () => {
  const dispatch = useDispatch();
  const { profile, errorMessage, successMessage } = useSelector(state => state.configuration);

  const [formData, setFormData] = useState({
    id: profile.id || 0,
    first_name: profile.first_name || '',
    last_name: profile.last_name || '',
    gender: profile.gender || 'M',
    date_of_birth: profile.date_of_birth || '',
    weight: profile.weight || '',
    weight_goal: profile.weight_goal || '',
    height: profile.height || '',
    activity_level: profile.activity_level || '',
    nutrition_goal: profile.nutrition_goal || '',
    nutrition_goal_pace: profile.nutrition_goal_pace || '',
    manual_macros: profile.manual_macros || 0,
    manual_protein_goal: profile.manual_protein_goal || '',
    manual_carb_goal: profile.manual_carb_goal || '',
    manual_fat_goal: profile.manual_fat_goal || '',
    override_disable_training_setting: profile.override_disable_training_setting || 'YES',
    active_favourite_plan_id: profile.active_favourite_plan_id || '',
  });

  useEffect(() => {
    dispatch(clearMessage());
  }, []); 

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    setFormData(prevState => ({
      ...prevState,
      ...profile,
    }));
  }, [profile]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(updateUserProfile(formData));
  };

 
  return (
    <Layout>
      <main className="main">
        <header>
          <div className="main-head flex justify-between align-center pb-0">
            <h1 className="greet-user-text">Personal Information & Goals</h1>
            <div className="ms-auto">
              <Back />
            </div>
          </div>
        </header>
        <div className="main-content flex justify-between flex-col-rev-mob">
          <div style={{ width: '100%' }}>
            <div className="meals-container meals-added">
            <h4><span style={{color:'#de2c2f'}}>Email</span> : {formData.email}</h4>
              <div className="card">
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label htmlFor="first_name">First Name</label>
                    <input
                      required
                      type="text"
                      name="first_name"
                      id="first_name"
                      value={formData.first_name}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="last_name">Last Name</label>
                    <input
                      required
                      type="text"
                      name="last_name"
                      id="last_name"
                      value={formData.last_name}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="gender">Gender</label>
                    <select name="gender" id="gender" value={formData.gender} onChange={handleInputChange}>
                      <option value="M">Male</option>
                      <option value="F">Female</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="date_of_birth">Date of Birth</label>
                    <input
                      required
                      type="date"
                      name="date_of_birth"
                      id="date_of_birth"
                      value={formData.date_of_birth}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="weight">Weight (KG)</label>
                    <input
                      required
                      type="number"
                      name="weight"
                      id="weight"
                      step="0.01"
                      value={formData.weight}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="weight_goal">Weight Goal (KG)</label>
                    <input
                      required
                      type="number"
                      name="weight_goal"
                      id="weight_goal"
                      step="0.01"
                      value={formData.weight_goal}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="height">Height (CM)</label>
                    <input
                      required
                      type="number"
                      name="height"
                      id="height"
                      step="0.01"
                      value={formData.height}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="activity_level">Activity Level</label>
                    <select name="activity_level" id="activity_level" value={formData.activity_level} onChange={handleInputChange}>
                      <option value="sedentary">Sedentary (office job)</option>
                      <option value="light">Light Exercise (1-2 days/week)</option>
                      <option value="moderate">Moderate Exercise (3-5 days/week)</option>
                      <option value="heavy">Heavy Exercise (6-7 days/week)</option>
                      <option value="athlete">Athlete (2x per day)</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="manual_macros">Macros Calculation</label>
                    <select name="manual_macros" id="manual_macros" value={formData.manual_macros} onChange={handleInputChange}>
                      <option value="0">Automatic</option>
                      <option value="1">Manual</option>
                    </select>
                  </div>
 
                   {formData && formData.manual_macros == '1' && (
                    <>
                      <div className="form-group">
                        <label htmlFor="manual_protein_goal">Protein Goal</label>
                        <input
                          type="number"
                          name="manual_protein_goal"
                          id="manual_protein_goal"
                          value={formData.manual_protein_goal}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="manual_carb_goal">Carb Goal</label>
                        <input
                          type="number"
                          name="manual_carb_goal"
                          id="manual_carb_goal"
                          value={formData.manual_carb_goal}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="manual_fat_goal">Fat Goal</label>
                        <input
                          type="number"
                          name="manual_fat_goal"
                          id="manual_fat_goal"
                          value={formData.manual_fat_goal}
                          onChange={handleInputChange}
                        />
                      </div>
                    </>
                  )}

                  <div className="form-group">
                    <label htmlFor="nutrition_goal">Nutrition Goal</label>
                    <select name="nutrition_goal" id="nutrition_goal" value={formData.nutrition_goal} onChange={handleInputChange}>
                      <option value="lose">Lose Body Fat</option>
                      <option value="maintain">Maintain</option>
                      <option value="gain">Gain Weight</option>
                    </select>
                  </div>                  

                  {formData && formData.nutrition_goal != 'maintain' && (
                    <div className="form-group">
                      <label htmlFor="nutrition_goal_pace">Nutrition Goal Pace</label>
                      <select
                        name="nutrition_goal_pace"
                        id="nutrition_goal_pace"
                        value={formData.nutrition_goal_pace}
                        onChange={handleInputChange}
                      >
                        <option value="slow">Slow</option>
                        <option value="normal">Normal (recommended)</option>
                        <option value="fast">Fast</option>
                      </select>
                    </div>
                  )}

                  <div className="form-group">
                    <button type="submit" className="btn">
                      Save
                    </button>
                  </div>
                </form>
                 {/* Display success or error message if it exists */}
                    {successMessage && (
                      <div className="alert alert-success">
                        {successMessage}
                      </div>
                    )}
                    {errorMessage && (
                      <div className="alert alert-danger">
                        {errorMessage}
                      </div>
                    )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default Profile;